import { MultiSelect } from "primereact/multiselect"
import { useOperations } from "../api/queries/useOperations"

export default function OperationMultiFilter(props) {
  const { data: operations = [] } = useOperations()

  return (
    <MultiSelect
      filter={true}
      showClear={true}
      options={operations}
      optionLabel={"name"}
      optionValue={"uuid"}
      placeholder={"Provoz"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
